import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "left fit-sm" }
const _hoisted_2 = {
  key: 0,
  class: "value"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "value"
}
const _hoisted_5 = {
  key: 2,
  class: "value"
}
const _hoisted_6 = { class: "mono" }
const _hoisted_7 = { class: "api-key-container" }
const _hoisted_8 = { class: "mono" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "carrier-group" }
const _hoisted_11 = { class: "before-options" }
const _hoisted_12 = { class: "float-right" }
const _hoisted_13 = { class: "ellipsis" }
const _hoisted_14 = { class: "dialog" }
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_clipable = _resolveComponent("clipable")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_editable_block = _resolveComponent("editable-block")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    readonly: _ctx.readonly,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:catalogue', _ctx.catalogue?.sys?.id, $event))),
    title: "Channel settings",
    layout: "grid",
    "model-value": _ctx.catalogue,
    "column-count": 2
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_editable_block_input, {
          readonly: _ctx.readonly,
          label: "ID",
          modelValue: editState.id,
          "onUpdate:modelValue": ($event: any) => ((editState.id) = $event),
          "disable-editing": "",
          tooltip: "The ID is automatically generated by Directify and can be found in the first number of the product’s Channel SKU code."
        }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          readonly: _ctx.readonly,
          label: "Name",
          modelValue: editState.name,
          "onUpdate:modelValue": ($event: any) => ((editState.name) = $event)
        }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          readonly: _ctx.readonly,
          label: "Client",
          modelValue: editState.client,
          "onUpdate:modelValue": ($event: any) => ((editState.client) = $event),
          error: !editState.client,
          tooltip: "Choose from one of the clients that have been added on the Clients page."
        }, {
          static: _withCtx(({ inputState }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.clientOptions?.find(co => co.value === (typeof inputState.value === 'object' ? inputState.value?.sys?.id : inputState.value))?.label), 1)
          ]),
          input: _withCtx(({ inputState }) => [
            _createVNode(_component_form_select, {
              "model-value": _ctx.clientOptions?.find(co => co.value === (typeof inputState.value === 'object' ? inputState.value?.sys?.id : inputState.value)),
              onSelect: e => inputState.value = e.value,
              type: "select",
              label: inputState.label,
              placeholder: "Choose a client",
              options: _ctx.clientOptions
            }, null, 8, ["model-value", "onSelect", "label", "options"])
          ]),
          _: 2
        }, 1032, ["readonly", "modelValue", "onUpdate:modelValue", "error"]),
        _createVNode(_component_editable_block_input, {
          readonly: _ctx.readonly,
          label: "Aliases",
          modelValue: editState.aliases,
          "onUpdate:modelValue": ($event: any) => ((editState.aliases) = $event),
          tooltip: "Add aliases to ensure possible typos or misspellings won’t affect the operation. E.g. when importing orders with a slightly different channel name it will still be picked up."
        }, {
          static: _withCtx(({ inputState }) => [
            _createElementVNode("span", null, _toDisplayString(inputState.value?.join(', ')), 1)
          ]),
          input: _withCtx(({ inputState }) => [
            _createVNode(_component_form_select, {
              modelValue: inputState.value,
              "onUpdate:modelValue": ($event: any) => ((inputState.value) = $event),
              type: "tag",
              label: inputState.label,
              placeholder: "Enter an alias",
              options: [],
              onClipboard: _ctx.clipped
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onClipboard"])
          ]),
          _: 2
        }, 1032, ["readonly", "modelValue", "onUpdate:modelValue"]),
        _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "label medium" }, "API Key", -1)),
        (editState.token?.access_token?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: _normalizeClass(["cursor-pointer", {'has-tooltip': editState.service?.id.startsWith('C_'), locked: editState.service?.id.startsWith('C_') }]),
                "data-tooltip": "The API Key for this channel cannot be changed, as it is connected to another Directify space",
                onClick: () => editState.service?.id.startsWith('C_') ? undefined : _ctx.showTokenModal = true
              }, _toDisplayString(editState.token.access_token.substring(0,5)+'...'+editState.token.access_token.substring(editState.token.access_token.length-5)), 11, _hoisted_3)
            ]))
          : (!_ctx.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  rounded: "",
                  color: "primary",
                  onClick: _ctx.showChannelTokenModal,
                  style: {"margin-top":"-8px"}
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Generate new API key")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, "No Api Key set")),
        _createVNode(_component_q_dialog, {
          class: "api-key-dialog",
          modelValue: _ctx.showTokenModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showTokenModal) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                (!_ctx.catalogue.token?.access_token)
                  ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                      default: _withCtx(() => [
                        _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "bold space-v2" }, "New Channel API Key", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "This will set the API key for this channel, giving API access to information, orders and products related to this channel.", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("u", null, "Copy it to a safe location, after confirming you will not be able to view the key again", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                        _cache[18] || (_cache[18] = _createElementVNode("a", {
                          href: "https://protiumdigital.notion.site/Orders-Fulfillments-API-2c81df0e539949afb2061227f3aeaf74",
                          target: "_blank"
                        }, "API docs", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_clipable, {
                          class: "api-key-clipable",
                          payload: _ctx.channelToken,
                          message: "API Key copied to clipboard"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.channelToken), 1)
                          ]),
                          _: 1
                        }, 8, ["payload"]),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          rounded: "",
                          color: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChannelToken(_ctx.channelToken)))
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("Confirm")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_q_btn, {
                          class: "space-h1",
                          unelevated: "",
                          rounded: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTokenModal = false))
                        }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("Cancel")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "bold" }, "API Key", -1)),
                        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                        _cache[25] || (_cache[25] = _createElementVNode("a", {
                          href: "https://protiumdigital.notion.site/Orders-Fulfillments-API-2c81df0e539949afb2061227f3aeaf74",
                          target: "_blank"
                        }, "API docs", -1)),
                        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(editState.token?.access_token.substring(0,5)+'...'+editState.token?.access_token.substring(editState.token?.access_token.length-5)), 1)
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                        _createVNode(_component_q_btn, {
                          class: "error",
                          unelevated: "",
                          rounded: "",
                          onClick: _ctx.clearChannelToken
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode("Remove key")
                          ])),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          unelevated: "",
                          rounded: "",
                          onClick: _ctx.regenerateChannelToken
                        }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("Regenerate key")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_editable_block_input, {
            readonly: _ctx.readonly,
            label: "Currency",
            modelValue: editState.currency,
            "onUpdate:modelValue": ($event: any) => ((editState.currency) = $event),
            tooltip: "The currency in which the channel operates."
          }, {
            static: _withCtx(({ inputState }) => [
              _createElementVNode("span", null, _toDisplayString(inputState.value), 1)
            ]),
            input: _withCtx(({ inputState }) => [
              _createVNode(_component_q_select, {
                "model-value": _ctx.currencyList.find(f => f.value === editState.currency) || null,
                "onUpdate:modelValue": ($event: any) => (editState.currency = $event?.value || null),
                options: _ctx.currencyList,
                "popup-content-style": "padding: 0;",
                onFilter: _ctx.filterFn,
                label: "Currency",
                "use-chips": "",
                "use-input": "",
                dense: ""
              }, null, 8, ["model-value", "onUpdate:modelValue", "options", "onFilter"])
            ]),
            _: 2
          }, 1032, ["readonly", "modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_editable_block_input, {
            readonly: _ctx.readonly,
            label: "Shipping carrier",
            modelValue: editState.shipping_carrier,
            "onUpdate:modelValue": ($event: any) => ((editState.shipping_carrier) = $event)
          }, {
            static: _withCtx(({ inputState }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.formattedCarriers.find(f=> f.value === inputState.value)?.label || inputState.value), 1)
            ]),
            input: _withCtx(({ inputState }) => [
              _createVNode(_component_q_select, {
                "model-value": _ctx.formattedCarriers.find(f => f.value === editState.shipping_carrier) || null,
                "onUpdate:modelValue": ($event: any) => (editState.shipping_carrier = $event?.value || null),
                options: _ctx.filteredFormattedCarrierList,
                "popup-content-style": "padding: 0;",
                onFilter: _ctx.filterFn,
                label: "Shipping Carrier(-group)",
                "popup-content-class": "select carrier-select",
                "use-chips": "",
                "use-input": "",
                dense: ""
              }, {
                "before-options": _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createVNode(_component_q_btn, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCreateCarrierGroup = true)),
                      flat: "",
                      label: "Create carrier group",
                      icon: "add"
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ])
                ]),
                option: _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_q_item, _mergeProps({
                    key: scope.index
                  }, scope.itemProps), {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(scope.label), 1),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(scope.opt.type), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040))
                ]),
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_q_chip, {
                    key: `option-${scope.index}`,
                    dense: "",
                    removable: "",
                    clickable: scope.opt.type === 'Carrier Group',
                    onClick: _withModifiers(($event: any) => (_ctx.onCarrierGroupClick(scope.opt)), ["stop","prevent"]),
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(scope.opt.label ?  scope.opt.label : scope.opt), 1)
                    ]),
                    _: 2
                  }, 1032, ["clickable", "onClick", "onRemove"]))
                ]),
                _: 2
              }, 1032, ["model-value", "onUpdate:modelValue", "options", "onFilter"])
            ]),
            _: 2
          }, 1032, ["readonly", "modelValue", "onUpdate:modelValue"])
        ]),
        _createVNode(_component_editable_block_input, {
          readonly: _ctx.readonly,
          label: "Shipping time target",
          modelValue: editState.shipping_time,
          "onUpdate:modelValue": ($event: any) => ((editState.shipping_time) = $event),
          tooltip: "Fill in the targeted time in which you wish to deliver the package."
        }, null, 8, ["readonly", "modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          readonly: _ctx.readonly,
          label: "Data map",
          modelValue: editState.map,
          "onUpdate:modelValue": ($event: any) => ((editState.map) = $event)
        }, {
          static: _withCtx(({ inputState }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.datamapOptions?.find(dm => dm.value === inputState.value)?.label), 1)
          ]),
          input: _withCtx(({ inputState }) => [
            _createVNode(_component_form_select, {
              "model-value": _ctx.datamapOptions?.find(dm => dm.value === inputState.value),
              onSelect: e => inputState.value = e.value,
              type: "select",
              label: inputState.label,
              placeholder: "Choose a data map",
              options: _ctx.datamapOptions
            }, null, 8, ["model-value", "onSelect", "label", "options"])
          ]),
          _: 2
        }, 1032, ["readonly", "modelValue", "onUpdate:modelValue"])
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showCreateCarrierGroup,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showCreateCarrierGroup) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.carrierGroup?.sys?.created_at ? 'Carrier-group' : 'Create Carrier-group'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_form_input, {
                        modelValue: _ctx.carrierGroup.name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.carrierGroup.name) = $event)),
                        label: "Carrier-group name",
                        autofocus: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_form_select, {
                        "model-value": _ctx.selectedCarriers,
                        "onUpdate:modelValue": _ctx.updateGroupCarriers,
                        label: "Select carriers",
                        options: _ctx.ShipmentCarriers.map(s => {return {value: s.sys.id, label: s.name}}),
                        type: "multi-select"
                      }, null, 8, ["model-value", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, {
                        "model-value": !_ctx.carrierGroup.process_initial ? false : true,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.carrierGroup.process_initial = $event),
                        label: "Auto-fulfill orders"
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        class: "q-mr-md",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCreateCarrierGroup=false, _ctx.resetCarrierGroup())),
                        unelevated: "",
                        rounded: ""
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_close_icon, { left: "" }, null, 512), [
                            [_directive_close_popup]
                          ]),
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Cancel", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_btn, {
                        onClick: ($event: any) => (_ctx.saveCarrierGroup(_ctx.carrierGroup, editState)),
                        unelevated: "",
                        rounded: "",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_tick_icon, { left: "" }),
                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "Save", -1))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 2
      }, 1032, ["modelValue"])
    ]),
    _: 1
  }, 8, ["readonly", "model-value"]))
}